import createBrowserFlushSignal from 'src/internal/common/createBrowserFlushSignal';
import createAelErrorsTransport from 'src/internal/errors/transport/createAelErrorsTransport';
import createBrowserFetch from 'src/internal/transport/createBrowserFetch';

import type {
  AelErrorsTransport,
  AelErrorsTransportConfig,
} from 'src/internal/errors/transport/types';
import type {ServiceName} from 'src/types';

const transportsMap: Record<ServiceName, AelErrorsTransport> = {};

function createTransport(
  service: ServiceName,
  partialConfig: Partial<AelErrorsTransportConfig>,
): AelErrorsTransport {
  return createAelErrorsTransport({
    fetch: partialConfig.fetch ?? createBrowserFetch(),
    service,
    flushSignal: partialConfig.flushSignal ?? createBrowserFlushSignal(),
  });
}

/**
 * Returns an AEL errors transport for the given service.
 * If the transport is not already created, it creates a new one and returns it.
 */
export default function getAelErrorsTransport(
  service: ServiceName,
  config: Partial<AelErrorsTransportConfig>,
): AelErrorsTransport {
  if (!transportsMap[service]) {
    transportsMap[service] = createTransport(service, config);
  }

  return transportsMap[service];
}
